import { render, staticRenderFns } from "./CliprLoader.vue?vue&type=template&id=564a17c8&scoped=true"
import script from "./CliprLoader.vue?vue&type=script&lang=js"
export * from "./CliprLoader.vue?vue&type=script&lang=js"
import style0 from "./CliprLoader.vue?vue&type=style&index=0&id=564a17c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a17c8",
  null
  
)

export default component.exports